import './WorkCard.css'
import React from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { NavLink } from 'react-router-dom'

const WorkCard = (props) => {

  // const notify = () => toast("Still working on it!");

  return (
    <div className='project-card'>
    <img src={props.imgsrc} alt="image" />
    <h2 className='project-title'>{props.title}</h2>
    <div className='pro-details'>
    <p>{props.text}</p>
    <div className='pro-btns'>
        <NavLink to={props.view} target='_blank' className='btn' >View</NavLink>
        <NavLink to={props.source} className='btn'>Source</NavLink>
        {/* <ToastContainer /> */}
        {/* onClick={notify} */}
    </div>
    </div>
</div>
  )
}

export default WorkCard